import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const Login = Loadable(lazy(() => import('views/pages/auth/Login/Login')));
const OrganizationBasicInfo = Loadable(lazy(() => import('views/pages/auth/OrganizationBasicInfo/OrganizationBasicInfo')));
const ForgotPassword = Loadable(lazy(() => import('views/pages/auth/ForgotPassword/ForgotPassword')));
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/Login',
      element: <Login />,
    },
    {
      path: '/Organization/BasicInfo',
      element: <OrganizationBasicInfo />,
    },
    {
      path: '/ForgotPassword',
      element: <ForgotPassword />,
    },
    // {
    //   path: '/pages/login/login3',
    //   element: <AuthLogin3 />
    // },
    // {
    //   path: '/pages/register/register3',
    //   element: <AuthRegister3 />
    // }
  ]
};

export default AuthenticationRoutes;
